




























































































import {
    Component,
    Prop,
    Vue,
    Inject,
    Provide,
    Watch
} from "vue-property-decorator";
@Component({
})
export default class HomeTop extends Vue{
    @Prop(String) readonly caption!:string;
    @Prop(Array) readonly data:any;
    

    get_circle_color(idx){
        return idx<=2?"":"info"
    }


    do_caption_click(item){
        window.open('https://club.isso.com.cn/default.aspx?class=UserInfo&User='+item.id)
    }
}
